var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2000,
    height: 2000,
    viewBox: "0 0 2000 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 184.16,
    width: 1815.84,
    height: 1815.84,
    rx: 267.39,
    fill: "#939393"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 184.16,
    width: 1815.84,
    height: 1815.84,
    rx: 267.39,
    fill: "#303030"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M907.79,367.78l-9.71,33v957.83l9.71,9.69,444.59-262.79Z",
    fill: "#9b9b9b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m907.79 367.78l-444.59 737.74 444.59 262.81",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M907.79,1452.52l-5.48,6.68v341.25l5.48,15.93,444.85-626.55Z",
    fill: "#9b9b9b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m907.79 1816.38l0-363.87-444.59-262.68",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M907.79,1368.33l444.58-262.81L907.79,903.43v464.9",
    fill: "#666"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m463.2 1105.52l444.58 262.81 0-464.9",
    fill: "#9b9b9b"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeth);
export default __webpack_public_path__ + "static/media/weth.b610526e39b6fb35c19a928b18c2ee16.svg";
export { ForwardRef as ReactComponent };